import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Form,
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';
import { useForm } from 'react-hook-form';

import { isNumberKey } from 'helpers/number';
import { handleToastError } from 'helpers/index';
import { closeAccessCode } from 'store/modal/index';

import useI18n from 'hooks/use-i18n';
import { useAccessCode } from 'hooks/modal/index';
import userEventApi from 'api/userEventApi';

import InputCounter from 'components/InputCounter/InputCounter';

const ModalInputAccessCode = () => {
  const dispatch = useDispatch();
  const i18n = useI18n();
  const accessCode = useAccessCode();
  const { isOpen, eventId } = accessCode;

  const handleClose = () => dispatch(closeAccessCode());

  const { register, handleSubmit, errors, reset, watch } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: { accessCode: '' },
  });

  const watchValue = watch(['accessCode']);

  const onSubmit = async (data) => {
    try {
      const link = await userEventApi.getLinkBBB(eventId, data.accessCode);
      window.open(link, '_blank');
    } catch (e) {
      handleToastError(e, i18n);
    }
  };

  useEffect(() => {
    if (isOpen) {
      reset();
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleClose}
      className="modal-dialog-centered"
      size="sm"
      contentClassName="p-0"
    >
      <ModalHeader toggle={handleClose}>
        <span className="view-page-title">Access code</span>
      </ModalHeader>
      <ModalBody className="pb-sm-0 pb-3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <FormGroup>
            <InputCounter
              max={6}
              type="text"
              name="accessCode"
              placeholder="Enter access code"
              onKeyPress={isNumberKey}
              invalid={!!errors?.accessCode}
              innerRef={register({
                validate: {
                  onlySixChar: (accessCode) => {
                    if (accessCode) {
                      return (
                        accessCode.length === 6 ||
                        'Password is only 6 characters long.'
                      );
                    }
                  },
                },
              })}
              propsValue={watchValue?.accessCode}
              isUseForm
            />
            <FormGroup className="text-center">
              <Button.Ripple
                type="submit"
                className="round mt-1"
                color="danger"
              >
                Join
              </Button.Ripple>
            </FormGroup>
          </FormGroup>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default ModalInputAccessCode;
